export const FACEBOOK_URL = process.env.REACT_APP_FACEBOOK_URL;
export const LINKEDIN_URL = process.env.REACT_APP_LINKEDIN_URL;
export const MAIL_URL = process.env.REACT_APP_MAIL_URL;
export const CONTACT_US_URL = process.env.REACT_APP_CONTACT_US_URL;
export const MOBILE = process.env.REACT_APP_MOBILE;
export const EMAIL = process.env.REACT_APP_EMAIL;
export const SUB_ADDRESS = process.env.REACT_APP_SUB_ADDRESS_1;
export const PARENT_ADDRESS = process.env.REACT_APP_PARENT_ADDRESS;
